<template>
  <svg
    id="SVGRoot"
    width="60.0px"
    height="60.0px"
    viewBox="0 0 60.0 60.0"
    version="1.1"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <g id="layer4">
      <path
        id="rect6153"
        d="M 24.46875,8.9453125 V 19.289062 H 41.779297 V 8.9453125 Z"
      />
      <path
        id="rect6163"
        d="M 42.222656,8.9453125 V 19.289062 H 58.054687 V 8.9453125 Z"
      />
      <path
        id="rect6143"
        d="M 8.195313,8.9453125 V 19.289062 H 24.025391 V 8.9453125 Z"
      />
      <path
        id="rect6143-2"
        d="M 8.195313,8.9453125 V 19.289062 H 24.025391 V 8.9453125 Z"
      />
      <path
        id="rect6168-4"
        d="m 35.45339,19.388012 v 10.34375 h 15.832031 v -10.34375 z"
      />
      <path
        id="rect6148-8"
        d="m 1.426046,19.388012 v 10.34375 h 15.830079 v -10.34375 z"
      />
      <path
        id="rect6158-5"
        d="m 17.699484,19.388012 v 10.34375 h 17.310547 v -10.34375 z"
      />
      <path
        id="rect6153-5"
        d="m 25.264313,29.772174 v 10.34375 H 42.57486 v -10.34375 z"
      />
      <path
        id="rect6163-8"
        d="m 43.018219,29.772174 v 10.34375 H 58.85025 v -10.34375 z"
      />
      <path
        id="rect6143-5"
        d="m 8.990875,29.772174 v 10.34375 h 15.830079 v -10.34375 z"
      />
      <path
        id="rect6168-4-7"
        d="m 36.248953,40.214873 v 10.34375 h 15.832031 v -10.34375 z"
      />
      <path
        id="rect6148-8-4"
        d="m 2.221609,40.214873 v 10.34375 h 15.830079 v -10.34375 z"
      />
      <path
        id="rect6158-5-4"
        d="m 18.495047,40.214873 v 10.34375 h 17.310547 v -10.34375 z"
      />
      <path
        id="rect6143"
        class="pop"
        d="M 8.195313,8.9453125 V 19.289062 H 24.025391 V 8.9453125 Z"
      />
      <path
        id="rect6168-4"
        class="pop"
        d="m 35.45339,19.388012 v 10.34375 h 15.832031 v -10.34375 z"
      />
      <path
        id="rect6148-8-4"
        class="pop"
        d="m 2.221609,40.214873 v 10.34375 h 15.830079 v -10.34375 z"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
path {
  stroke: $background-color-default;
  fill: $primary-color;
}
.pop {
  opacity: 0;
  fill: $secondary-color;
}
svg:hover {
  .pop {
    transition: opacity 0.5s ease;
    opacity: 1;
  }
}
</style>
